import { KiteGrid, KiteGridCell } from '@kite/react-kite';
import './FeaturedArticle.scss';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import React from 'react';
import { SmartLink } from '../SmartLink/SmartLink';

export interface FeaturedArticleInputs {
    title: string;
    text: string;
    cta: {
        text: string;
        uri: string;
    };
    image: {
        gatsbyImage: any;
        alt: string;
    };
}

export const FeaturedArticle = ({
    inputs,
}: {
    inputs: FeaturedArticleInputs;
}) => {
    const gImage = getImage(inputs.image.gatsbyImage);
    return (
        <section className="paragraph__featured-article kite-container">
            <KiteGrid>
                <KiteGridCell col={6}>
                    <h2 className="typestack-title-3">{inputs.title}</h2>
                    <div
                        className="text"
                        dangerouslySetInnerHTML={{
                            __html: inputs.text,
                        }}
                    ></div>
                    <SmartLink
                        button={true}
                        url={inputs.cta.uri}
                        ariaLabel={`${inputs.title} - ${inputs.cta.text}`}
                    >
                        {inputs.cta.text}
                    </SmartLink>
                </KiteGridCell>
                <KiteGridCell col={6}>
                    <GatsbyImage alt={inputs.image.alt} image={gImage} />
                </KiteGridCell>
            </KiteGrid>
        </section>
    );
};
